import { call, put, takeLatest } from "redux-saga/effects";
import {
  getSchoolProfileRequest,
  getSchoolProfileSuccess,
} from "./schoolProfileSlice"; 
import { getSchoolByID } from "../../api/SchoolService/SchoolService";

function* fetchSchoolProfileSaga(action) {
  try {
    const { schoolID } = action.payload;
     if (!schoolID) {
      yield put(getSchoolProfileSuccess([]));
      return;
    }
    const response = yield call(getSchoolByID, schoolID);
    yield put(getSchoolProfileSuccess(response?.data)); 
  } catch (error) {
    yield put(getSchoolProfileSuccess([])); 
  }
}

export default function* watchSchoolProfile() {
  yield takeLatest(getSchoolProfileRequest.type, fetchSchoolProfileSaga);
}

